module.exports = __webpack_public_path__ + "static/media/9.dae8ad93.svg";